import PropTypes from "prop-types"
import React, { useContext, useEffect } from "react"
import { useQuery } from "react-query"
import { useNavigate } from "react-router-dom"

import { queryReturnedLaunches } from "src/api/DryStack"

import MarinaScheduleMobileList from "./MarinaScheduleMobileList"
import MarinaScheduleTable from "./MarinaScheduleTable"
import { MarinaScheduleContext } from "./MarinaScheduleView"

const ReturnedTabContainer = ({ marinaSlug }) => {
  const { lastActionTakenAt, isLargeScreen } = useContext(MarinaScheduleContext)
  const navigate = useNavigate()
  const { isLoading, isError, data } = useQuery(
    ["returnedLaunches", marinaSlug, lastActionTakenAt],
    () => queryReturnedLaunches(marinaSlug),
    {
      retry: false,
      refetchOnMount: false,
      refetchInterval: 60 * 1000,
    }
  )
  useEffect(() => {
    navigate("/?tab=returned")
  }, [navigate])

  const blankStateCopy = "No boats returned in the past 48 hours"

  return (
    <div className="flex flex-col">
      {data && data.scheduleAppointments?.length > 0 && (
        <span className="mb-3 w-full px-4 text-base lg:w-2/3 lg:pl-0 lg:text-sm">
          Showing boats that have been marked as returned to their dry storage
          slip in the past 48 hours.
        </span>
      )}
      {isLargeScreen ? (
        <MarinaScheduleTable
          blankStateCopy={blankStateCopy}
          data={data}
          isError={isError}
          isLoading={isLoading}
          titleCell="Returned"
        />
      ) : (
        <MarinaScheduleMobileList
          blankStateCopy={blankStateCopy}
          data={data}
          isError={isError}
          isLoading={isLoading}
          titleCell="Returned"
        />
      )}
    </div>
  )
}

ReturnedTabContainer.propTypes = {
  marinaSlug: PropTypes.string.isRequired,
}

export default ReturnedTabContainer
